module.exports = __webpack_public_path__ + "static/img/IMG_20160103_100918.aa7fa94a.jpg";